import PropTypes from 'prop-types'
import classnames from 'classnames'
import MCElement from '../../MCElement'
import TooltipText from '../../TooltipText'
import { ItemCardProps } from '../../../../constants/dual-panel-selector-constants'
import classes from './ItemCard.module.scss'
import Avatar from '../../avatar/avatar'

const CoachCard = ({ item: coach, isChecked, onCheckChange, className, isSelectable }) => (
  <div
    className={classnames(
      'd-flex align-items-center',
      className,
      classes.itemWrapper,
      {
        [classes.selected]: !isSelectable,
      })}

  >
    {isSelectable && (
      <div className={classes.checkboxWrapper}>
        <MCElement
          type='checkbox'
          isSelected={isChecked}
          clicked={() => onCheckChange(isChecked, coach)}
        />
      </div>
    )}

    <div className={classnames('d-flex justify-content-between flex-grow-1', { 'ml-5': isSelectable })}>
      <div className='d-flex align-items-center'>
        <Avatar
          className='img-responsive'
          imageUrl={coach.avatar?.file_url}
          hasCoachLabel
          hasBorder
          altName={coach.first_name + ' ' + coach.last_name}
          size={40}

        />
        <div className='d-flex flex-column ml-3'>
          <TooltipText
            className={classes.title}
            text={`${coach.firstName || coach.first_name} ${coach.lastName || coach.last_name}`}
          />
        </div>
      </div>
    </div>
  </div>
)

CoachCard.propTypes = {
  ...ItemCardProps,
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string,
  }).isRequired,
}

export default CoachCard
